import { useParams } from 'react-router';

import { BenefitItem } from './components/BenefitItem/BenefitItem';
import { EmailDetails } from './components/EmailDetails/EmailDetails';
import styles from './SpendingLimitRequestLanding.module.css';
import { useGetSellerByHandle } from '../../api/lending/lapiHooks';
import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen';
import IwocaPayIcon from '../../components/svg/IwocaPayIcon.svg?react';
import { useSellerWhitelabelling } from '../../hooks/useSellerWhiteLabelling.hook';
import { GenericError } from '../../Pages/FailurePages/GenericError';
import { useThreatMetrix } from '../../utils/ThreatMetrix';
import { HelpBox } from '../components/HelpBox/HelpBox';
import { WhiteLabelPayLinkLogo } from '../components/WhiteLabelLogo/WhiteLabelLogo';
import { useTrackLandingPageView } from '../hooks/useTrackLandingPageView';
import { useRedirectToMyAccount } from '../Signup/useRedirectToAccountPages';

export const SpendingLimitRequestLanding = () => {
  const { sellerHandle } = useParams();
  const { sellerError, seller, loadingSeller } =
    useGetSellerByHandle(sellerHandle);

  // White-label theme.
  const { theme, showSellerLogo } = useSellerWhitelabelling(sellerHandle);

  useTrackLandingPageView({
    payLinkType: 'spending_limit',
    visibleOptions: ['THREE_MONTHS'],
    productPricing: seller?.product_pricing!,
    sellerId: seller?.seller_id,
    loadingApis: loadingSeller,
  });

  useThreatMetrix();

  useRedirectToMyAccount();

  if (sellerError) {
    return <GenericError errorText={sellerError} />;
  }
  if (!seller) {
    return <LoadingScreen />;
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.content}>
        <div className={styles.createSpendingLimitContainer}>
          {showSellerLogo && (
            <WhiteLabelPayLinkLogo
              // showSellerLogo = true --> logo_uri & preferred_logo_type present.
              url={theme!.logo_uri!}
              ratio={theme!.preferred_logo_type!}
              themeColor={theme!.primary_color}
              className="mt-0"
            />
          )}
          {!showSellerLogo && <IwocaPayIcon className={styles.iwocaPayLogo} />}
          <div className={styles.heading}>Create your account today</div>
          <ul className={styles.benefits}>
            <BenefitItem>Sign up in 3 minutes</BenefitItem>
            <BenefitItem>Access up to £30k to spend</BenefitItem>
            <BenefitItem>Get more time to pay</BenefitItem>
          </ul>
          <EmailDetails />
        </div>
        <HelpBox />
      </div>
    </div>
  );
};
